import './debug_gui.js';
import * as THREE from 'three';
import { loader } from './loader.js';
import { onResize } from './resize.js';
import { initRaycaster } from './raycaster.js';
import { makeCSS2Dannotaition, initCSS2DRenderer, hideInvisibleAnns } from './annotations.js';
import { animations } from './animations.js';
import { materials } from './materials.js';
import { sceneHandler } from './scene.js';
import * as Camera from './Camera.js';
import { EffectComposer, RenderPass } from 'postprocessing';
import Stats from 'three/examples/jsm/libs/stats.module.js';
import { servObj } from './init_glob.js';
import { applyTile } from './tile_configurate.js';
import {hideLoaderElement, showLoaderElement} from "./loaderElement.js"
import {applyFasadTexture, applyRoofColor, applyDrainageSystemColor, applyWindowsDoorsColor, applyPlinthTexture} from "./house_configurate.js"
import {applyFenceTexture} from "./fence_configurate.js"

var stats = new Stats();
stats.showPanel(0); // 0: fps, 1: ms, 2: mb, 3+: custom
// document.body.appendChild(stats.dom);

const container3D = document.querySelector('.d3d-container');
const foreground = document.querySelector('.foreground');

let composer, renderPass, n8aopass;
const renderer = new THREE.WebGLRenderer({
    antialias: true,
    // outputColorSpace: THREE.SRGBColorSpace,
    stencil: true,
});
renderer.toneMapping = THREE.ACESFilmicToneMapping;
renderer.shadowMap.enabled = true;
renderer.shadowMap.needsUpdate = true;
renderer.shadowMap.type = THREE.PCFSoftShadowMap;
const canvas = renderer.domElement;
container3D.appendChild(canvas);

renderer.setSize(container3D.offsetWidth, container3D.offsetHeight);
renderer.localClippingEnabled = true;

window.container3D = container3D;
window.container3D.foreground = foreground;
window.container3D.canvas = canvas;

const annRenderer = initCSS2DRenderer(container3D);

const scene = new THREE.Scene();
servObj.scene = scene;
scene.background = new THREE.Color(0xffffff);
// scene.fog = new THREE.Fog(new THREE.Color(0xFFFFFF), 30, 90);
const bgFolder = gui.addFolder('Background');
bgFolder.addColor(scene, 'background').onFinishChange((event) => console.log(event.getHexString()));
// bgFolder.addColor(scene.fog, 'color').onFinishChange((event) => console.log(event.getHexString()));
// bgFolder.add(scene.fog, 'near');
// bgFolder.add(scene.fog, 'far');

let activeCamera;

scene.setActiveCamera = (camera) => {
    activeCamera = camera;
    scene.activeCamera = camera;
    renderPass.camera = activeCamera;

    onResize(scene.activeRenderer, activeCamera, container3D);
};
scene.activeRenderer = renderer;
scene.renderer = renderer;
scene.annRenderer = annRenderer;
scene.composer = null;

export const sceneLoadPromise = new Promise(function (resolve, reject) {
    loader.loadGLTF('./3d/porevit.glb', async (gltf) => {
        scene.add(gltf.scene);
        scene.animations = gltf.animations;
        //Init block
        animations.initHandler(scene);
        activeCamera = new Camera.Perspective(canvas);
        initRaycaster(scene, activeCamera);

        onResize(renderer, activeCamera, container3D);

        servObj.perspectiveCamera = activeCamera;
        onResize(annRenderer, activeCamera, container3D);

        window.addEventListener('resize', () => onResize(scene.activeRenderer, activeCamera, container3D));
        window.addEventListener('resize', () => onResize(annRenderer, activeCamera, container3D));

        composer = new EffectComposer(renderer, { multisampling: 8, stencilBuffer: true });
        renderPass = new RenderPass(scene, activeCamera);
        composer.addPass(renderPass);
        scene.composer = composer;
        gui.add(scene, 'activeRenderer', { renderer: scene.renderer, composer: scene.composer });

        sceneHandler.init(scene);

        gltf.scene.getObjectByName("grass").position.y = -0.045
        gltf.scene.getObjectByName("flor_tile").position.y = -0.01

        resolve();

        animate();

        applyPlinthTexture(servObj.defaultHouse.plinthTexture, false)
        applyFasadTexture(servObj.defaultHouse.fasadTexture, false)
        applyRoofColor(servObj.defaultHouse.roofColor)
        applyDrainageSystemColor(servObj.defaultHouse.drainageSystemColor)
        applyWindowsDoorsColor(servObj.defaultHouse.windowsDoorsColor)
        applyFenceTexture(servObj.defaultFence.textureName, servObj.defaultFence.rusTextureName, false)
        

        applyTile(() => {})

        gltf.scene.children.forEach(obj=>{
            if(obj.name.includes('ann_')) makeCSS2Dannotaition(obj);
        })
    }, e => {
        //document.querySelector(".preloader_filled").style.backgroundPosition = `${(1 - (e.loaded / 25797764) * 0.8) * 100}% 0`
        //console.log(e)
        document.querySelector(".preloader_fon").style.width = `${e.loaded / 13061536 * 0.8 * 100}%`
        document.querySelector(".loader-procent").innerText = `${Math.round((e.loaded / 13061536) * 0.8 * 100)}%`
    })
});

servObj.isFirstLoading = true

const clock = new THREE.Clock();

function animate() {

    stats.begin();
    const deltaTime = clock.getDelta();

    activeCamera.update(deltaTime);
    if (servObj.perspectiveCamera.controls.autorotate && !servObj.perspectiveCamera.controls.disableAutoRotate) {
        servObj.perspectiveCamera.controls.azimuthAngle += 5 * deltaTime * THREE.MathUtils.DEG2RAD;
    }

    animations.update(deltaTime);

    materials.updatableMaterials.forEach((mat) => mat.animationUpdate(deltaTime));

    // renderer.render(scene, activeCamera);
    // composer.render();
    scene.activeRenderer.render(scene, activeCamera);
    stats.end();

    requestAnimationFrame(animate);

    annRenderer.render(scene, activeCamera);
    // скрыть перекрываемые  аннотации при движении (используется raycaster, сильно тормозит приложение)
    // hideInvisibleAnns(activeCamera, servObj && servObj.annotations)

    if(servObj.isChangingMode == true){
        servObj.isChangingMode = false
        setTimeout(() => hideLoaderElement(false, true), 1000)  
    }
}
